var exports = {
  "uW": "GiftSection.module__section___UFdqNW",
  "xQ": "GiftSection.module__footerContainer___UFdqNW",
  "$P": "GiftSection.module__scrollPromptContainer___UFdqNW",
  "Zq": "GiftSection.module__scrollPromptText___UFdqNW",
  "$O": "GiftSection.module__scrollPromptIcon___UFdqNW",
};

module.exports = exports;
